export type ShortcutMenuRenderMode = 'hidden' | 'empty-selection' | 'layer-menu' | 'default-menu';

interface IResolveShortcutMenuRenderModeOptions {
    visible: boolean;
    hasActiveLayer: boolean;
    blocked: boolean;
    hasLayerMenu: boolean;
    defaultMenuEnabled: boolean;
}

/** 按统一优先级决定当前快捷菜单的唯一渲染分支 */
export const resolveShortcutMenuRenderMode = ({
    visible,
    hasActiveLayer,
    blocked,
    hasLayerMenu,
    defaultMenuEnabled,
}: IResolveShortcutMenuRenderModeOptions): ShortcutMenuRenderMode => {
    if (!visible) return 'hidden';
    if (!hasActiveLayer) return 'empty-selection';
    if (blocked) return 'hidden';
    if (hasLayerMenu) return 'layer-menu';
    if (defaultMenuEnabled) return 'default-menu';
    return 'hidden';
};
